import React, { useState } from 'react'
import { Box, Text, Flex, Group, Button } from '@mantine/core'
import { submitQuoteSourcingRequest } from '../../../services/sourcing-request'
import { notificationSuccess, notificationError } from '../../ui/Notifications'

const FormSubmitQuote = ({ dataSourcingRequest, onCloseModal, reloadList }) => {
  const [loadingForm, setLoadingForm] = useState(false)

  const submitRequestQuote = async (sourcingRequest) => {
    setLoadingForm(true)
    try {
      const response = await submitQuoteSourcingRequest(sourcingRequest.id)
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess('Submit Quote Sourcing Request Successfully', 'You have been added quote data sourcing request')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please contact administrator'
      notificationError('Submit Quote Sourcing Request Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }
  
  return (
    <Box>
      <Box ta='center' my={10}>
        <Text fz={18} fw='bold' c='red'>Create Quote for this Request ?</Text>
        <Text fz={18} fw='bold' my={10}>{dataSourcingRequest !== null ? dataSourcingRequest.request_number : ''}</Text>
        <Text fz={12} c='gray.7'>Are you sure want to create quote for this request? </Text>
        <Text fz={12} c='gray.7'>The quote that will be created will be entered on the Request Quote page.</Text>
      </Box>
      <Box mt={40}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitRequestQuote(dataSourcingRequest)}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
    
  )
}

export default FormSubmitQuote